import Joyride, { type CallBackProps } from "react-joyride";
import { joyrideLocale, joyrideStyles } from "./joyrideConfig";
import { otRequestFormForEmployeeTourSteps } from "./otRequestFormForEmployeeTourSteps";
import { useOvertimeTour } from "./useOvertimeTour";

const TOUR_STORAGE_KEY = "hr-overtime-request-form-for-employee-tour-completed";

type OTRequestFormForEmployeeTourProps = {
  run: boolean;
  onCallback: (data: { status?: string; type?: string; index?: number }) => void;
};

export function OTRequestFormForEmployeeTour({
  run,
  onCallback,
}: OTRequestFormForEmployeeTourProps) {
  const handleCallback = (data: CallBackProps) => {
    onCallback({ status: data.status, type: data.type, index: data.index });
  };

  return (
    <Joyride
      steps={otRequestFormForEmployeeTourSteps}
      run={run}
      continuous
      showProgress
      showSkipButton
      callback={handleCallback}
      locale={joyrideLocale}
      styles={joyrideStyles}
      scrollToFirstStep
      scrollOffset={24}
      scrollDuration={300}
    />
  );
}

export function useOTRequestFormForEmployeeTour() {
  return useOvertimeTour(TOUR_STORAGE_KEY);
}
